import React, { useEffect, useState } from 'react';
import { useStore } from '../../contexts/StoreProvider';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

const StoreScreen = () => {
  const { products, categories, fetchProducts, fetchCategories, toggleFavorite, isLoading } = useStore();
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  useEffect(() => {
    fetchCategories();
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCategorySelect = (categoryId) => {
    setSelectedCategoryId(categoryId);
    fetchProducts(categoryId);
  };

  return (
    <div className="flex flex-col space-y-6">
      {/* Categories */}
      <div className="flex overflow-x-auto py-2 space-x-3 scrollbar-hide">
        <button
          onClick={() => handleCategorySelect(null)}
          className={`px-6 py-2 whitespace-nowrap text-sm font-semibold uppercase tracking-wider transition-colors border ${
            selectedCategoryId === null
              ? 'bg-black text-white border-black'
              : 'bg-white text-black border-gray-300 hover:border-black'
          }`}
        >
          All Items
        </button>
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => handleCategorySelect(cat.id)}
            className={`px-6 py-2 whitespace-nowrap text-sm font-semibold uppercase tracking-wider transition-colors border ${
              selectedCategoryId === cat.id
                ? 'bg-black text-white border-black'
                : 'bg-white text-black border-gray-300 hover:border-black'
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>

      {/* Product Grid */}
      {isLoading ? (
        <div className="flex justify-center items-center py-20">
          <div className="w-10 h-10 border-4 border-black border-t-transparent rounded-full animate-spin"></div>
        </div>
      ) : products.length === 0 ? (
        <div className="text-center py-20 text-gray-500">
          No products found.
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <div key={product.id} className="group flex flex-col bg-white overflow-hidden hover:shadow-lg transition-shadow duration-300">
              <div className="relative aspect-[3/4] bg-gray-100 overflow-hidden">
                {product.images && product.images.length > 0 ? (
                  <img
                    src={product.images[0].image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-gray-400">
                    No Image
                  </div>
                )}
                
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleFavorite(product.id);
                  }}
                  className="absolute top-3 right-3 p-2 bg-white/90 backdrop-blur rounded-full hover:bg-white transition-colors shadow-sm z-10"
                >
                  <Heart
                    size={20}
                    className={product.isFavorite ? "fill-red-500 text-red-500" : "text-black"}
                  />
                </button>
                
                {/* Overlay link to avoid wrapping button in link */}
                <Link to={`/store/product/${product.id}`} className="absolute inset-0 z-0"></Link>
              </div>
              
              <div className="p-4 flex flex-col flex-grow">
                <span className="text-[10px] font-bold tracking-widest text-gray-500 uppercase mb-1">
                  {product.category_detail?.name || 'GENERAL'}
                </span>
                <Link to={`/store/product/${product.id}`} className="text-sm font-semibold text-black hover:underline mb-2 line-clamp-1">
                  {product.name}
                </Link>
                <span className="text-base font-bold text-black mt-auto">
                  ₵{parseFloat(product.price).toFixed(2)}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StoreScreen;
